module.exports = __webpack_public_path__ + "img/histoire-patrimoine.87e5cb10.jpg";